/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {FilterDrawerFavoriteFilledIcon} from '../icons/current/FilterDrawerFavoriteFilledIcon';
import {FilterFavoriteWorkingIcon} from '../icons/current/FilterFavoriteWorkingIcon';
import Render from '../render/Render';
import {IconSize} from '../types/types';
import {AppliedFilterBarFavoriteState} from './AppliedFilterBarTypes';

export interface AppliedFilterBarFavoriteIconProps {
  state: AppliedFilterBarFavoriteState;
}

/**
 * Displays the saved or working favorite indicator in the applied filter bar.
 */
export const AppliedFilterBarFavoriteIcon = ({
  state
}: AppliedFilterBarFavoriteIconProps) => (
  <Render.If condition={state !== AppliedFilterBarFavoriteState.None}>
    {state === AppliedFilterBarFavoriteState.Working
      ? <FilterFavoriteWorkingIcon size={IconSize.medium} />
      : <FilterDrawerFavoriteFilledIcon size={IconSize.medium} />}
  </Render.If>
);

export default memo(AppliedFilterBarFavoriteIcon);
